import React from 'react'
import { awardType } from '../../strings/types'
import { withRouter } from 'react-router-dom'
import { formSchema } from './schema'
import { OpDivReferralForm } from './OpDivReferralForm'
import {
  formatAwards,
  formatEmploymentData,
  formatPersonData,
  normalizeSubjectData,
  formatYesNoToTrueFalse,
  reduceObject,
  saveComplaint
} from '../../utilities'

import withRecaptcha from '../withRecaptcha'

export class OpDivReferral extends React.Component {
  state = {
    focusFieldName: undefined
  }

  componentDidUpdate() {
    // Set the focus on an input field, if one is given
    if (this.state.focusFieldName) {
      const element = document.getElementsByName(this.state.focusFieldName)[0]
      element
        ? element.focus()
        : console.log('unknown field name: ', this.state.focusFieldName)
    }
  }

  render() {
    return (
      <OpDivReferralForm
        schema={formSchema(this._onSubmit, this._setFocusName)}
      />
    )
  }

  _formatComplainantData = data => ({
    ...formatPersonData(data),
    employment: formatEmploymentData(data)
  })

  _formatDetailData = data => {
    const rawData = reduceObject(
      [
        'business_unit',
        'confirmation_email',
        'evidence_description',
        'grant_contract_number',
        'hhs_program',
        'hhs_program_detail',
        'office_of_secretary',
        'poc_reporting'
      ],
      data
    )

    return {
      ...rawData,
      poc_reporting: formatYesNoToTrueFalse(data.poc_reporting)
    }
  }

  _formatSubmissionData = data => {
    const { complaint_type, documents, narrative, ...rest } = data

    const detail = this._formatDetailData(rest)
    if (complaint_type === 'grant_contract_fraud') {
      detail.contracts = formatAwards(rest.awards, awardType.contract)
      detail.grants = formatAwards(rest.awards, awardType.grant)
    }

    const complainant = this._formatComplainantData(rest)
    const subjectData = normalizeSubjectData(rest, 9)

    return Object.freeze({
      analyst_complaint_type: complaint_type,
      complaint_type,
      complainant,
      detail,
      documents,
      narrative,
      recaptcha_score: this.props.recaptchaScore,
      source: 'opdiv',
      subjects: subjectData
    })
  }

  _onSubmit = values => {
    saveComplaint(
      this._formatSubmissionData(values),
      this.props.history,
      '/opdiv-referral/confirmation'
    )
  }

  // Is called when user clicks Edit link on the InspectOpDiv page
  _setFocusName = fieldName => this.setState({ focusFieldName: fieldName })
}

export default withRecaptcha(withRouter(OpDivReferral))
